import {
  BANNER_MESSAGE_HIDE,
  BANNER_MESSAGE_SHOW,
  FLASH_MESSAGE_HIDE,
  FLASH_MESSAGE_SHOW,
} from '../../actionTypes/FlashMessage/FlashMessages';
import Api from '../../Api';
import Constants from '../../Constants';

function showStatusMsg(msg) {
  return {
    type: FLASH_MESSAGE_SHOW,
    payload: { ...msg },
  };
}

function showBannerMsg(msg) {
  return {
    type: BANNER_MESSAGE_SHOW,
    payload: { ...msg },
  };
}

export function hideStatusMsg() {
  return (dispatch) => dispatch({ type: FLASH_MESSAGE_HIDE });
}

export function hideBannerMsg() {
  return (dispatch) => dispatch({ type: BANNER_MESSAGE_HIDE });
}

export function onWelcomeMsg(boldMsg, msg, pageLocation = '') {
  const msgObj = { boldMsg, msg, msgType: 'welcome', msgShow: true, pageLocation };

  return (dispatch) => {
    dispatch(showStatusMsg(msgObj));
  };
}

export function onSuccessMsg(boldMsg) {
  const msgObj = { boldMsg, msg: null, msgType: 'success', pageLocation: '', };
  return (dispatch) => {
    dispatch(showStatusMsg(msgObj));
  };
}

export function onWarningMsg(msg) {
  const msgObj = { boldMsg: null, msg, msgType: 'warning', msgShow: true };

  return (dispatch) => {
    dispatch(showStatusMsg(msgObj));
  };
}

export function onErrorMsg(msg, pageLocation = '') {
  if (!msg) {
    msg = 'Oops! Something went wrong. Please try again later';
  }
  const msgObj = { boldMsg: null, msg, msgType: 'error', msgShow: true, pageLocation };

  return (dispatch) => {
    dispatch(showStatusMsg(msgObj));
  };
}

export const fetchBannerMsg = () => {
  return (dispatch) => {
    const api = new Api();
    api
      .getData(Constants.apiUrls.banners, {})
      .then((res) => {
        if (res.message) {
          dispatch(showBannerMsg({ msg: res.message, msgShow: true }));
        } else {
          dispatch(hideBannerMsg());
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
};
